import React from 'react';
import { cn } from '@/lib/utils';
import Link from 'next/link';
import parse from 'html-react-parser';
interface QuoteProps {
  quote?: string;
  quoteAuthor?: string;
  quoteAuthorLink?: string;
  quoteSubline?: string;
  attributes?: React.HTMLProps<HTMLDivElement>;
}

export const Quote = ({ quote, quoteAuthor, quoteAuthorLink, quoteSubline, attributes }: QuoteProps) => {
  const { key, ...rest } = attributes ?? {};
  const sectionClass = cn(
    'content-quote',
  );
  const blockquoteClass = cn(
    'flex flex-col gap-y-6 mb-6 pl-8 py-10 border-l-4 border-gradient-primary',
  );
  const quoteSublineClass = cn(
    'not-italic paragraph-lg text-muted-foreground',
  );
  const quoteAuthorClass = cn(
    'not-italic paragraph-lg text-foreground font-bold',
  );

  return (
    <div
      key={key}
      {...rest}
      className={sectionClass}
    >
      <blockquote className={blockquoteClass}>
        <div className="heading-4">{parse(quote ?? '')}</div>
        <div className="flex flex-col gap-0">
          {quoteAuthorLink && quoteAuthor && <cite className={quoteSublineClass}><Link className="underline" href={quoteAuthorLink ?? ''}>{quoteAuthor ?? ''}</Link></cite>}
          {quoteAuthor && !quoteAuthorLink && <cite className={quoteAuthorClass}>{quoteAuthor ?? ''}</cite>}
          {quoteSubline && <cite className={quoteSublineClass}>{quoteSubline ?? ''}</cite>}
        </div>
      </blockquote>
    </div>
  );
}; 